module.exports = __webpack_public_path__ + "static/img/32-Inspired-villages-later-living-communities.95902901.jpg";